@use "../../../../../../../../../styles/Colors.scss" as Colors;
@use "../../../../../../../../../styles/Constants.scss" as Constants;

.MaterialEntryCheckable {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	padding: Constants.$val-spacing-xs Constants.$val-spacing-m;
	margin-top: Constants.$val-spacing-xxs;

	.materialeEntry {
		flex: 1;
	}
}
